import {
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import {MatIcon} from '@angular/material/icon';
import {
  MatMenu,
  MatMenuItem,
  MatMenuTrigger,
} from '@angular/material/menu';
import {MatButton} from '@angular/material/button';
import {AsyncPipe} from '@angular/common';
import {
  Component,
  inject,
  input,
  InputSignal,
} from '@angular/core';
import {Store} from '@ngrx/store';
import {toSignal} from '@angular/core/rxjs-interop';
import {AppState} from '../../store/store';
import {
  ALL_LANGUAGES,
  Language,
} from '../../enums/language.enum';
import {selectIsPreviewMode} from '../../store/shared-link/shared-link.selectors';
import {
  getActualLanguage,
  saveLang,
} from '../../functions/translate-utils';
import {loadContactDataOrPortalDataAfterSwitchLanguage} from '../../store/contact/contact.actions';

@Component({
  selector: 'app-lang-menu',
  imports: [TranslatePipe, MatIcon, MatMenuTrigger, MatButton, MatMenu, MatMenuItem, AsyncPipe],
  templateUrl: './lang-menu.component.html',
  styleUrl: './lang-menu.component.scss',
})
export class LangMenuComponent {

  private readonly store: Store<AppState> = inject(Store<AppState>);

  public readonly translateService: TranslateService = inject(TranslateService);

  public readonly fullWidth: InputSignal<boolean> = input<boolean>(false);

  public allLanguages = ALL_LANGUAGES;

  public previewMode$ = this.store.select(selectIsPreviewMode);

  private isPreviewMode = toSignal(this.previewMode$, {initialValue: false});

  constructor() {
    if (!this.isPreviewMode()) {
      this.translateService.use(getActualLanguage());
    }
  }

  onSetLang(language: Language): void {
    if (language !== this.translateService.currentLang) {
      if (!this.isPreviewMode()) {
        saveLang(language);
      }

      this.translateService.use(language);
      this.store.dispatch(loadContactDataOrPortalDataAfterSwitchLanguage());
    }
  }

}
